import VerticalSplit from './VerticalSplit';

export default VerticalSplit;
